import { ApplicationElement, html } from '@effectivastudio/lit-components';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';

import '../profile_avatar/element.js';
import '@effectivastudio/lit-components/components/timeago/element.js';

import style from './style.lit.css';

/**
 * Notification item with picture, title and info content.
 *
 * @prop createdAt - Time of notification creation
 * @prop href - Link leading to entire notification content
 * @prop isRead - When true, indicates the notification was read
 * @prop isPermanent - If true, indicates permanent notification
 * @prop picture - When present, shows user, group or content image
 * @prop pictureAlt - Alternative text for image
 *
 * @slot default - Notification content
 *
 * @cssprop --background - Component's background color
 * @cssprop --font - Font size
 * @cssprop --link-text-hover - Link hover color
 * @cssprop --link-text-active - Link active color
 */

export default class Notification extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    createdAt: { type: Date },
    href: { type: String },
    isRead: { type: Boolean },
    isPermanent: { type: Boolean },
    picture: { type: String },
    pictureAlt: { type: String },
  };

  /** @internal */
  get classes() {
    return {
      read: this.isRead,
      permanent: this.isPermanent,
    };
  }

  handleClick() {
    this.isRead = true;
  }

  renderStatus() {
    return html`<div class="status"></div>`;
  }

  render() {
    return html` <a
      href=${this.href}
      class=${classMap(this.classes)}
      @click=${this.handleClick}>
      <div class="content">
        <ef-img-placeholder
          .picture=${this.picture}
          alt=${ifDefined(this.pictureAlt)}
          rounded="true">
        </ef-img-placeholder>

        <div class="info">
          <div>
            <slot></slot>
          </div>
          <ef-timeago .timestamp=${this.createdAt}></ef-timeago>
        </div>
      </div>

      ${!this.isRead ? this.renderStatus() : null}
    </a>`;
  }
}

customElements.get('xs-notification') ||
  customElements.define('xs-notification', Notification);
